import { Dropdown, DropdownListItem } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, memo, useCallback, useEffect, useRef, useState } from "react";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import styled from "styled-components";

const DropdownMainWrapper = styled.div<{isOpen: boolean, disableChange?: boolean}>`
    display: flex;
    color: ${p => p.disableChange? '#909090' : '#151514'};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    align-items: center;
    justify-content: space-between;
    background: #F2F2F2;
    position: relative;
    cursor: default;
    svg {
        width: 16px;
        height: 16px;
        ${p=> p.isOpen && 'transform: rotate(180deg);'}
        position: absolute;
        cursor: pointer;
        right: 16px;
    }
    input {
        padding: 14px 44px 14px 16px;
        background: transparent;
        border: none;
        outline: none;
        display: flex;
        cursor: pointer;
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
        
        input {
            padding: 12px 44px 12px 16px;
        }
    }
`

const DropdownList = styled.div<{openToUp?: boolean}>`
    display: flex;
    flex-direction: column;
    position: absolute;
    ${p => p.openToUp? 'bottom' : 'top'}: 100%;
    left: 0;
    width: 100%;
    z-index: 1;
    max-height: calc(40px * 4);
    height: fit-content;
    overflow-y: scroll;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    &::-webkit-scrollbar {
        width: 4px !important;
    }
    &::-webkit-scrollbar-track {
        background: #E7E7E7 !important;
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
        border-radius: 2px;
        width: 4px;
        height: 96px;
    }
    .dropdown-list-item {
        font-size: inherit;
        line-height: inherit;
        letter-spacing: inherit;
    }
`

const MetricsDropdown = (props: any) => {
    const {dropdownValue, setDropdownValue, valuesList: values, disableChange} = props

    const [isOpen, setIsOpen] = useState(false)
    const ref = useRef<any>(null)

    const closeDropdown = useCallback(() => {
        if (isOpen)  {
            setIsOpen(false)
        }
    }, [isOpen])

    // useEffect(() => {
    //     window.addEventListener('click', closeDropdown)
    //     return () => window.removeEventListener('click', closeDropdown)
    // }, [closeDropdown])

    return  <DropdownMainWrapper onClick={() => {
        if (!disableChange) {
                setIsOpen(!isOpen)
                ref.current?.focus()
            }
        }} 
        isOpen={isOpen} disableChange={disableChange}>
                        <input
                            readOnly
                            type="text"
                            onBlur={() => setIsOpen(false)}
                            value={typeof dropdownValue === 'string' ? dropdownValue : values[dropdownValue]}
                            ref={ref}
                        />
                        {/* <span>
                            {typeof dropdownValue === 'string' ? dropdownValue : values[dropdownValue]}
                        </span> */}
                        <svg onClick={(e) => {
                            e.stopPropagation()
                            setIsOpen(!isOpen)
                        }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 11.158L2.25981 5.22347C1.97161 4.92551 1.50435 4.92551 1.21615 5.22348C0.927948 5.52144 0.927951 6.00453 1.21615 6.30249L7.47817 12.7765C7.76637 13.0745 8.23363 13.0745 8.52183 12.7765L14.7838 6.30249C15.072 6.00453 15.0721 5.52144 14.7839 5.22348C14.4957 4.92551 14.0284 4.92551 13.7402 5.22347L8 11.158Z" fill="#909090"/>
                        </svg>
                        {isOpen? <DropdownList openToUp={props.openToUp}>
                            {
                                Object.entries(values).map(([key, value]: any[]) => <DropdownListItem 
                                    isActive={key === dropdownValue} 
                                    key={value} 
                                    onMouseDown={() => {if (!disableChange) setDropdownValue(key)}}
                                >{value.name || value.periodName || value}</DropdownListItem>)
                          }
                        </DropdownList> : undefined}
            </DropdownMainWrapper>     
}

export default memo(MetricsDropdown)import { Dropdown, DropdownListItem } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, memo, useCallback, useEffect, useRef, useState } from "react";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import styled from "styled-components";

const DropdownMainWrapper = styled.div<{isOpen: boolean, disableChange?: boolean}>`
    display: flex;
    color: ${p => p.disableChange? '#909090' : '#151514'};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    align-items: center;
    justify-content: space-between;
    background: #F2F2F2;
    position: relative;
    cursor: default;
    svg {
        width: 16px;
        height: 16px;
        ${p=> p.isOpen && 'transform: rotate(180deg);'}
        position: absolute;
        cursor: pointer;
        right: 16px;
    }
    input {
        padding: 14px 44px 14px 16px;
        background: transparent;
        border: none;
        outline: none;
        display: flex;
        cursor: pointer;
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
        
        input {
            padding: 12px 44px 12px 16px;
        }
    }
`

const DropdownList = styled.div<{openToUp?: boolean}>`
    display: flex;
    flex-direction: column;
    position: absolute;
    ${p => p.openToUp? 'bottom' : 'top'}: 100%;
    left: 0;
    width: 100%;
    z-index: 1;
    max-height: calc(40px * 4);
    height: fit-content;
    overflow-y: scroll;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    &::-webkit-scrollbar {
        width: 4px !important;
    }
    &::-webkit-scrollbar-track {
        background: #E7E7E7 !important;
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
        border-radius: 2px;
        width: 4px;
        height: 96px;
    }
    .dropdown-list-item {
        font-size: inherit;
        line-height: inherit;
        letter-spacing: inherit;
    }
`

const MetricsDropdown = (props: any) => {
    const {dropdownValue, setDropdownValue, valuesList: values, disableChange} = props

    const [isOpen, setIsOpen] = useState(false)
    const ref = useRef<any>(null)

    const closeDropdown = useCallback(() => {
        if (isOpen)  {
            setIsOpen(false)
        }
    }, [isOpen])

    // useEffect(() => {
    //     window.addEventListener('click', closeDropdown)
    //     return () => window.removeEventListener('click', closeDropdown)
    // }, [closeDropdown])

    return  <DropdownMainWrapper onClick={() => {
        if (!disableChange) {
                setIsOpen(!isOpen)
                ref.current?.focus()
            }
        }} 
        isOpen={isOpen} disableChange={disableChange}>
                        <input
                            readOnly
                            type="text"
                            onBlur={() => setIsOpen(false)}
                            value={typeof dropdownValue === 'string' ? dropdownValue : values[dropdownValue]}
                            ref={ref}
                        />
                        {/* <span>
                            {typeof dropdownValue === 'string' ? dropdownValue : values[dropdownValue]}
                        </span> */}
                        <svg onClick={(e) => {
                            e.stopPropagation()
                            setIsOpen(!isOpen)
                        }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 11.158L2.25981 5.22347C1.97161 4.92551 1.50435 4.92551 1.21615 5.22348C0.927948 5.52144 0.927951 6.00453 1.21615 6.30249L7.47817 12.7765C7.76637 13.0745 8.23363 13.0745 8.52183 12.7765L14.7838 6.30249C15.072 6.00453 15.0721 5.52144 14.7839 5.22348C14.4957 4.92551 14.0284 4.92551 13.7402 5.22347L8 11.158Z" fill="#909090"/>
                        </svg>
                        {isOpen? <DropdownList openToUp={props.openToUp}>
                            {
                                Object.entries(values).map(([key, value]: any[]) => <DropdownListItem 
                                    isActive={key === dropdownValue} 
                                    key={value} 
                                    onMouseDown={() => {if (!disableChange) setDropdownValue(key)}}
                                >{value.name || value.periodName || value}</DropdownListItem>)
                          }
                        </DropdownList> : undefined}
            </DropdownMainWrapper>     
}

export default memo(MetricsDropdown)